import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { useAlert } from 'react-alert';
import CustomSelect from '../AddMedicines/CustomSelect';
import { optionsList } from '../AddMedicines/formOptions';

const TestShow = ({ selected, selectedTest, handleSuccess, sample, data }) => {
    const [testData, setTestData] = useState({
        id: selectedTest.id || '',
        sample: selectedTest.sample || sample,
        name: selectedTest.test_name || selectedTest.panel_name || '',
        unit: selectedTest.unit || '',
        note: selectedTest.note || '',
    });

    const [refRange, setRefRange] = useState(
        selectedTest.reference_parameter
            ? selectedTest.reference_parameter
            : [
                {
                    category: '',
                    min_value: '',
                    max_value: '',
                },
            ]
    );

    const [panels, setPanels] = useState(
        selectedTest.related_panel_ids?.map((panelId) => ({
            value: panelId,
            label: data.panels.find((panel) => panel.id === panelId)?.panel_name || '',
        }))
    );

    const [panelsList, setPanelsList] = useState(
        data.panels?.map((panel) => ({
            value: panel.id,
            label: panel.panel_name,
        }))
    );

    const [tests, setTests] = useState([]);
    const [testsList, setTestsList] = useState(data.tests?.map((test) => ({
        value: test.id,
        label: test.test_name,
    })));

    const [error, setError] = useState({
        sample: '',
        panels: '',
        tests: '',
    });

    const alert = useAlert();

    useEffect(() => {
        setTestData({
            id: selectedTest.id || '',
            sample: selectedTest.sample || sample,
            name: selectedTest.test_name || selectedTest.panel_name || '',
            unit: selectedTest.unit || '',
            note: selectedTest.note || '',
        });

        setRefRange(
            selectedTest.reference_parameter
                ? selectedTest.reference_parameter
                : [
                    {
                        category: '',
                        min_value: '',
                        max_value: '',
                    },
                ]
        );
        if (selected === 'panels') {
            const filteredTests = data.tests.filter((test) =>
                test.related_panel_ids.includes(selectedTest.id)
            );
            setTests(
                filteredTests.map((test) => ({
                    value: test.id,
                    label: test.test_name,
                }))
            );
        } else {
            setPanels(
                selectedTest.related_panel_ids?.map((panelId) => ({
                    value: panelId,
                    label: data.panels.find((panel) => panel.id === panelId)?.panel_name || '',
                }))
            );
        }
    }, [selectedTest, data.panels, data.tests, sample, selected]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTestData((current) => ({
            ...current,
            [name]: value,
        }));
    };

    const handleRefRangeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedRefRange = [...refRange];
        updatedRefRange[index][name] = value;
        setRefRange(updatedRefRange);
    };

    const handleRefChange = (index, selectedOption) => {
        const updatedRefRange = [...refRange];
        updatedRefRange[index].category = selectedOption.value;
        setRefRange(updatedRefRange);
    };

    const addRefRange = () => {
        setRefRange([
            ...refRange,
            {
                category: '',
                min_value: '',
                max_value: '',
            },
        ]);
    };

    const removeRefRange = (index) => {
        const updatedRefRange = refRange.filter((_, i) => i !== index);
        setRefRange(updatedRefRange);
    };

    const handlePanelChange = (selectedOptions) => {
        setError((currentState) => ({
            ...currentState,
            tests: '',
        }));

        if (!selectedOptions) {
            setPanels([]);
            return;
        }

        setPanels(selectedOptions);
    };

    const handleTestChange = (selectedOptions) => {
        setError((currentState) => ({
            ...currentState,
            tests: '',
        }));

        if (!selectedOptions) {
            setTests([]);
            return;
        }

        setTests(selectedOptions);
    };

    const handleSubmit = () => {
        if (!sample) {
            setError((currentState) => ({ ...currentState, sample: 'Sample is required.' }));
            return;
        }
        if (selected === 'test') {
            const invalidRanges = refRange.some(range => {
                const hasSomeFields = range.category || range.min_value || range.max_value;
                const hasAllFields = range.category && range.min_value && range.max_value;

                return hasSomeFields && !hasAllFields;
            });

            if (invalidRanges) {
                alert.error('Please complete all fields for each reference range (category, min, and max values)');
                return;
            }

        }


        const payload = {
            [selected === 'test' ? 'test_id' : 'panel_id']: selectedTest.id,
            [selected === 'test' ? 'test_name' : 'panel_name']: testData.name,
            ...(selected === 'test' && {
                panel_ids: panels.map((panel) => panel.value),
                unit: testData.unit,
                note: testData.note,
                reference_parameter: refRange.filter(range =>
                    range.category && range.min_value && range.max_value
                ),
            }),
            ...(selected === 'panels' && {
                test_ids: tests.map((test) => test.value),
            }),
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString.replace(/["]+/g, '');
        axios
            .put(`${APIURL}/api/v1/staff/lab-test/?${TZ}`, payload, {
                headers: {
                    Authorization: 'Token ' + str,
                },
            })
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success('Updated successfully!');
                    handleSuccess();
                } else {
                    alert.error(res.data.message || 'Failed to update test.');
                }
            })
            .catch((err) => {
                alert.error('Failed to update test. Please try again.');
            });
    };

    return (
        <div style={{ height: "454px", overflowY: "auto", padding: "10px" }}>
            <div className="panel-container">
                <div><span style={{ color: "#55479F", fontWeight: 500, textTransform: "capitalize" }}>{selectedTest.test_name || selectedTest.panel_name}</span></div>
                <div className='pricing-inputcontainer'>
                    <span>{selected === 'test' ? 'Test Name' : 'Panel Name'}</span>
                    <input
                        name="name"
                        placeholder='name'
                        value={testData.name}
                        onChange={handleInputChange}
                    />
                </div>
                {selected === 'test' && (
                    <>
                        <div className='pricing-inputcontainer'>
                            <span>Unit</span>
                            <input
                                name="unit"
                                placeholder='Unit'
                                value={testData.unit}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Reference Range</span>
                            {refRange.map((range, index) => (
                                <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                                    <div className='col-5' style={{ padding: 0 }}>
                                        <CustomSelect
                                            options={optionsList}
                                            name="category"
                                            placeholder='Category'
                                            value={optionsList.find(option => option.value === range.category) || null}
                                            onChange={(selectedOption) => handleRefChange(index, selectedOption)}
                                        />
                                    </div>
                                    <input className='col-3'
                                        name="min_value"
                                        placeholder='Min Value'
                                        value={range.min_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    <input className='col-3'
                                        name="max_value"
                                        placeholder='Max Value'
                                        value={range.max_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    <button
                                        className='remove-btn'
                                        onClick={() => removeRefRange(index)}
                                    >
                                        -
                                    </button>
                                </div>
                            ))}
                            <button className='add-btn' onClick={addRefRange}>
                                Add Reference Range
                            </button>
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Note</span>
                            <input
                                name="note"
                                placeholder='Note'
                                value={testData.note}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Panels</span>
                            <Select
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '27vw',
                                        minHeight: '44px',
                                        border: error.tests ? '1px solid red' : '1px solid #E3E3E3',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        // maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                    menuList: (provided) => ({
                                        ...provided,
                                        maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                }}
                                isMulti
                                value={panels}
                                onChange={handlePanelChange}
                                options={panelsList}
                                placeholder="Select Panels"
                            />
                            {error.panels && <p style={{ color: 'red' }}>{error.panels}</p>}
                        </div>
                    </>
                )}

                {selected === 'panels' && (
                    <div className='pricing-inputcontainer'>
                        <span>Tests</span>
                        <Select
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    width: '27vw',
                                    minHeight: '44px',
                                    border: error.tests ? '1px solid red' : '1px solid #E3E3E3',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    //  maxHeight: '200px!important',
                                    zIndex: 9999,
                                }),
                                menuList: (provided) => ({
                                    ...provided,
                                     maxHeight: '200px!important',
                                    zIndex: 9999,
                                }),
                            }}
                            isMulti
                            value={tests}
                            onChange={handleTestChange}
                            options={testsList}
                            placeholder="Select Tests"
                        />
                        {error.tests && <p style={{ color: 'red' }}>{error.tests}</p>}
                    </div>
                )}

                <button className='add-btn' style={{ margin: "auto auto 10px auto" }} onClick={handleSubmit}>
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default TestShow;